import { useState, useEffect } from 'react';

let hasDetected = false;
const listenerSet = new Set();

// 標記「線上已有新版」；輪詢與 chunk 載入失敗兩個來源共用，設過即定，重複呼叫為 no-op。
export function markNewVersionDetected() {
	if (hasDetected) {
		return;
	}

	hasDetected = true;
	listenerSet.forEach(listener => listener());
}

// 訂閱新版信號：偵測到新版後轉 true 並觸發重繪；mount 當下若已偵測到也立即補上。
export function useNewVersionDetected() {
	const [hasNewVersion, setHasNewVersion] = useState(hasDetected);

	useEffect(() => {
		if (hasDetected) {
			setHasNewVersion(true);
		}

		const listener = () => setHasNewVersion(true);

		listenerSet.add(listener);

		return () => listenerSet.delete(listener);
	}, []);

	return hasNewVersion;
}
